import { render } from "./TemplateMfittBooking2.vue?vue&type=template&id=3f185072"
import script from "./TemplateMfittBooking2.vue?vue&type=script&lang=js"
export * from "./TemplateMfittBooking2.vue?vue&type=script&lang=js"
script.render = render

export default script